<template>
    <div>
        <div class="flex-space-between">
            <div>
                <app-stepper-section label="Nome do Aparelho">
                    <v-text-field label="Nome do Aparelho"
                                  name="NOME"
                                  v-model="name"
                                  v-validate="'required'"></v-text-field>
                </app-stepper-section>
                <app-stepper-section label="Tempo de Conexão">
                    <div class="timeout">
                        <app-select v-model="timeoutType"
                                    data-title="Selecione"
                                    :data-search="false"
                                    :data-items="timeoutTypes"
                                    :clearable="false"/>
                        <v-text-field label="Tempo"
                                      name="TEMPO"
                                      v-model="timeout"
                                      v-validate="'required'"
                                      mask="#####"
                                      return-masked-value></v-text-field>
                    </div>
                </app-stepper-section>
            </div>
            <div>
                <app-stepper-section label="Tipo de Aparelho">
                    <app-select v-model="deviceType"
                                data-title="Selecione"
                                :data-search="false"
                                :data-items="deviceTypes"
                                :clearable="false"/>
                </app-stepper-section>
                <app-stepper-section label="Vincular Estabelecimento">
                    <app-select v-model="establishment"
                                data-title="Estabelecimentos"
                                data-menu-heading=""
                                data-menu-width="290px"
                                :data-button-gradient="true"
                                :data-items="listEstablishment"
                                @search="v => searchEstablishments(v)"/>
                </app-stepper-section>
            </div>

        </div>
        <div class="flex-space-between key-device">
            <div v-if="deviceType != 'MIKROTIK' && deviceType != 'FORTIGATE_FIREWALL' && deviceType != 'TPLINK_GATEWAY_STANDALONE' ">
                <app-stepper-section label="Chave do Aparelho">
                    <v-text-field label="Chave"
                                  name="CHAVE"
                                  v-model="chave"
                                  v-validate="'required'"></v-text-field>
                </app-stepper-section>

            </div>
            <div style="padding-top: 30px;">
                <app-toggle v-model="isSomenteMaiorIdade"></app-toggle>
                <span class="ml-2">Somente para maiores de idade</span>
            </div>
        </div>
        <div class="flex-center">

            <v-textarea
                v-model="notes"
                rows="4"
                maxlength="500"
                label="Anotações"
            ></v-textarea>
        </div>
    </div>
</template>

<script>
    import AppStepperSection from '@components/StepperSection'
    import AppSelect from '@components/Select'
    import AppToggle from '@components/Toggle'
    import _ from 'lodash'

    export default {
        components: {
            AppStepperSection,
            AppSelect,
            AppToggle,
        },
        data() {
            return {
                listEstablishment:[],
                deviceTypes: [
                    {id: 'MIKROTIK', label: 'Mikrotik'},
                    {id: 'CISCO_MERAKI', label: 'Meraki (Cisco)'},
                    {id: 'INTELBRAS', label: 'Intelbras'},
                    {id: 'UNIFI', label: 'Unifi (Ubiquiti)'}
                ],
                timeoutTypes:[
                    {id: 'MINUTO', label: 'MINUTO'},
                    {id: 'HORA', label: 'HORA'},
                    {id: 'DIA', label: 'DIA'},
                ]
            }
        },
        props: {
            value: {
                type: Object
            }
        },

        computed: {
            isSomenteMaiorIdade: {
                get() {
                    if (!this.value.isSomenteMaiorIdade){
                        return false
                    }

                    return this.value.isSomenteMaiorIdade
                },
                set(isSomenteMaiorIdade) {
                    this.$emit('input', {...this.value, isSomenteMaiorIdade})
                },
            },
            name: {
                get() {
                    return this.value.name
                },
                set(name) {
                    this.$emit('input', {...this.value, name})
                },
            },
            chave:{
                get() {
                    return this.value.chave
                },
                set(chave) {
                    this.$emit('input', {...this.value, chave})
                },
            },
            notes: {
                get() {
                    return this.value.notes
                },
                set(notes) {
                    this.$emit('input', {...this.value, notes})
                },
            },
            timeoutType: {
                get() {
                    return this.value.timeoutType
                },
                set(timeoutType) {
                    this.$emit('input', {...this.value, timeoutType})
                },
            },
            timeout: {
                get() {
                    return this.value.timeout
                },
                set(timeout) {
                    this.$emit('input', {...this.value, timeout})
                },
            },
            deviceType: {
                get() {
                    return this.value.deviceType
                },
                set(deviceType) {
                    this.$emit('input', {...this.value, deviceType})
                },
            },
            establishment: {
                get() {
                    return this.value.establishment
                },
                set(establishment) {
                    this.$emit('input', {...this.value, establishment})
                },
            },
            filtersEstablishments() {
                return this.$store.state.users.filters
            },
        },
        watch: {
            filtersEstablishments() {
                this.loadEstablishments()
            }
        },

        methods:{

            async loadEstablishments() {
                const payload = {
                    pagination: {
                        page: 0,
                        amountPerPage: 50,
                    },
                    filters: this.filtersEstablishments
                }

                let list= await this.$loader.users.list(payload)
                this.listEstablishment = _.map(list,
                    (user) => {
                        return {
                            id: user.id,
                            label: user.nome
                        }
                    }
                )
            },

            searchEstablishments(search) {
                this.$store.commit('USERS_SET_FILTER', {
                    key: 'search',
                    value: search,
                    userType : 'ESTABELECIMENTO'
                })
            },
        },
        mounted() {
            this.$store.commit('USERS_SET_FILTER', {
                key: 'userType',
                value: 'ESTABELECIMENTO'
            })
            this.loadEstablishments()
        }

    }
</script>
<style lang="scss" scoped>
    h3{
        text-align: center;
        font-weight: bold;
    }

    .timeout{
        display: flex;

        .v-text-field {
            padding-left: 10px;
        }
    }

    .update-login-type{
        text-align: center;
        width: 100%;
        display: block;
    }

    .key-device{
        margin-bottom: 10px;
    }

    .stepper-section{
        width: 300px;
        height: 110px;
        text-align: center;
        overflow: visible;
    }
</style>
